<script>
import {DateUtil} from '@/utils/date.js'
import {PlannRoute} from '@/utils/planningRoute.js'
import dialog from '@/components/Dialog'
export default {
  components: {'v-dialog': dialog},
  data () {
    return {
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '確定している便ですが、実行しますか？',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 选择的时的集合
      hourList: [],
      // 选择的分的集合
      minuteList: [],
      //  便経由地情報数组
      shiftPasspoints: [],
      // 经由地的个数
      passpointNum: 0,
      //  预约情報数组
      shiftReservationInfos: [],
      // route和停留所信息
      routeStationInfo: [],
      // 被选中的route相关的所有信息
      selectedRouteStationInfo: [],
      // 旧的ルートId
      oldRouteId: '',
      // route变化标志
      routeChangeFlag: false,
      // 路组件  下拉框 第一次进入没有值 给个默认值
      selectChange: false,
      // 时间校验标志位
      timeValidateFlag: false,
      // 修改前传入的时台
      oldTimeHour: '',
      // 修改前传入的分钟
      oldTimeMinute: '',
      // 出发地和终着地时间校验标志位
      startEndTimeValidateFlag: false,
      timeError: false,
      shiftTimeError: false
    }
  },
  props: {
    // 行归flag:默认为行
    goBackFlag: { type: String, default: '0' },
    // 予約者数
    reserveNumber: { type: Number, default: 0 },
    // ルートId
    routeId: '',
    // 親側インデックス
    shiftIndex:'',
    transportKind: 0,
    shiftId: ''
  },
  mounted () {
    // 获取route下拉框和停留所相关信息
    // this.routeStationInfo = JSON.parse(sessionStorage.getItem('routeStationInfo'))
    // console.log("this.routeStationInfo")
    // console.log(this.routeStationInfo)
    // console.log(this.routeId)
    // this.oldRouteId = this.routeId
    // this.chooseRoute(this.routeId)
    // this.getShiftPasspoints()
  },
  watch: {
    // selectedRouteStationInfo (newValue) {
    //   this.getShiftPasspoints()
    // },
    routeId (newValue) {
      console.log("routeId")
      console.log(newValue)
      this.chooseRoute(newValue)
      this.getShiftPasspoints()
      this.timeValidateFlag = false
      // this.startEndTimeValidateFlag = false
    },
    goBackFlag (newValue) {
      this.hourList = []
      this.minuteList = []
      this.timeValidateFlag = false
      this.startEndTimeValidateFlag = false
    },
    hourList () {
      this.watchHourMinuteValidate()
    },
    minuteList () {
      this.watchHourMinuteValidate()
    }

  },
  methods: {
    // editorのload完了後、ShiftInfoComponent.vueのwatchで呼び出し
    mountedFunc(){
      console.log("editor MountedFunc")
            // 获取route下拉框和停留所相关信息
      this.routeStationInfo = JSON.parse(sessionStorage.getItem('routeStationInfo'))
      console.log("this.routeStationInfo")
      console.log(this.routeStationInfo)
      console.log(this.routeId)
      this.oldRouteId = this.routeId
      this.chooseRoute(this.routeId)
      this.getShiftPasspoints()
    },
    // 时间校验
    timeValidate () {
      if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
        if (this.hourList[this.shiftPasspoints.length - 1] === undefined ||
          this.minuteList[this.shiftPasspoints.length - 1] === undefined) {
          this.timeValidateFlag = true
          return false
        }
      } else {
        if (this.hourList[0] === undefined ||
          this.minuteList[0] === undefined) {
          this.timeValidateFlag = true
          return false
        }
      }
      return true
    },
    // 实时监控时分的校验
    watchHourMinuteValidate () {
      // alert(this.hourList[0])
      if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
        if (this.hourList[this.shiftPasspoints.length - 1] !== undefined &&
           this.minuteList[this.shiftPasspoints.length - 1] !== undefined) {
          this.timeValidateFlag = false
        }
      } else {
        if (this.hourList[0] !== undefined &&
            this.minuteList[0] !== undefined) {
          this.timeValidateFlag = false
        }
      }
    },
    // 将出发地和终着地时间校验标志位置为true，触发验证
    triggerValidate () {
      this.startEndTimeValidateFlag = true
    },
    // 根据具体情况整合经由地集合数据shiftPasspoints
    getShiftPasspoints () {
      console.log("editor getShiftPasspoints")
      this.shiftPasspoints = []
      this.hourList = []
      this.minuteList = []
      console.log("this.reserveNumber")
      console.log(this.reserveNumber)
      console.log("this.routeChangeFlag")
      console.log(this.routeChangeFlag)
      console.log("this.selectedRouteStationInfo")
      console.log(this.selectedRouteStationInfo)
      if (this.reserveNumber === 0 && this.routeChangeFlag === true) {
        // 1、根据selectedRouteStationInfo重新生成shiftPasspoints，处理hourMin、minuteList以及passpointNum
        for (let i = 0; i < this.selectedRouteStationInfo.length; i++) {
          let shiftPasspoint = {}
          shiftPasspoint.shiftId = ''
          shiftPasspoint.routeNo = i
          shiftPasspoint.sortNo = i + 1
          shiftPasspoint.startEstimateTime = ''
          shiftPasspoint.arriveEstimateTime = ''
          shiftPasspoint.stopFlag = true
          shiftPasspoint.routeType = '0'
          if (i === 0) {
            shiftPasspoint.index = 'S'
          } else {
            if (i === this.selectedRouteStationInfo.length - 1) {
              shiftPasspoint.index = 'G'
            } else {
              // shiftPasspoint.index = i
              shiftPasspoint.index = 'G' + (i)
            }
          }
          shiftPasspoint.name = this.selectedRouteStationInfo[i].stationName
          shiftPasspoint.stationName = this.selectedRouteStationInfo[i].stationName
          shiftPasspoint.stationId = this.selectedRouteStationInfo[i].stationId
          shiftPasspoint.stationLat = this.selectedRouteStationInfo[i].stationLat
          shiftPasspoint.stationLng = this.selectedRouteStationInfo[i].stationLng
          shiftPasspoint.officeFlag = this.selectedRouteStationInfo[i].officeFlag
          shiftPasspoint.startPassengers = []
          this.shiftPasspoints[i] = shiftPasspoint
        }
        console.log("getShiftPasspoints1")
        console.log(this.shiftPasspoints)
      } else {
        let shiftDetail = {}
        // if (this.$route.query.editorIsCancel === 'true' || this.$route.query.editorIsCancel === true) {
        //   // event取消前修改的信息
        //   shiftDetail = JSON.parse(sessionStorage.getItem('eventShiftDetail'))
        // } else {
          // shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
          console.log("oldShiftDetail")
          console.log(JSON.parse(sessionStorage.getItem('shiftDetail')))

          console.log("JSON.parse(sessionStorage.getItem('shiftDetailList'))")
          let shiftDetailList = JSON.parse(sessionStorage.getItem('shiftDetailList'))
          shiftDetailList = shiftDetailList.shiftDetailList
          console.log(shiftDetailList)

          // shiftDetailListの中からこのコンポーネントを呼び出しているshiftIdと一致するものを取得
          for(let i = 0; i < shiftDetailList.length; i++){
            if(shiftDetailList[i].shiftInfo.shiftId == this.shiftId){
              shiftDetail = shiftDetailList[i]
            }
          }
          console.log("shiftDetail")
          console.log(shiftDetail)
        // }
        // let shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
        let shiftInfo = shiftDetail.shiftInfo
        this.shiftReservationInfos = shiftInfo.shiftReservationInfos
        let shiftDetailPasspoints = shiftInfo.shiftPasspoints

        // stopFlag（停車フラグ）を設定する
        // 出発地、到着地、乗車予約がある停留所、降車予約がある停留所、乗車予約がある自宅で停車する
        let reserveIndex = 1
        let stationIndex = 1
        for(let i = 0; i < shiftDetail.shiftPasspoints.length; i++){
          shiftDetail.shiftPasspoints[i].stopFlag = false
          shiftDetail.shiftPasspoints[i].showPassengers = false
          if(shiftDetail.shiftPasspoints[i].index == "S"){
            // 出発地
            shiftDetail.shiftPasspoints[i].stopFlag = true
          }else if(shiftDetail.shiftPasspoints[i].index == "G"){
            // 到着地
            shiftDetail.shiftPasspoints[i].stopFlag = true
          }else if(shiftDetail.shiftPasspoints[i].routeType == "1"){
            // 自宅
            shiftDetail.shiftPasspoints[i].stopFlag = true
            // 自宅のindexは独自のものを振り直す
            shiftDetail.shiftPasspoints[i].index = reserveIndex
            shiftDetail.shiftPasspoints[i].reserveIndex = reserveIndex
            reserveIndex++

            // その自宅の利用者の名前を探す
            for(let j = 0; j < shiftDetail.shiftInfo.shiftReservationInfos.length; j++){
              if(shiftDetail.shiftPasspoints[i].reserveId == shiftDetail.shiftInfo.shiftReservationInfos[j].reserveId){
                // 出発地
                shiftDetail.shiftPasspoints[i].name = shiftDetail.shiftInfo.shiftReservationInfos[j].lastName + ' ' + shiftDetail.shiftInfo.shiftReservationInfos[j].firstName
                shiftDetail.shiftPasspoints[i].stationName = shiftDetail.shiftPasspoints[i].name
                shiftDetail.shiftPasspoints[i].stationLat = shiftDetail.shiftInfo.shiftReservationInfos[j].homeLat
                shiftDetail.shiftPasspoints[i].stationLng = shiftDetail.shiftInfo.shiftReservationInfos[j].homeLng
              }
            }
          }else{
            // 通常の停留所は先頭にGをつけて振り直す Gの意味は不明
            shiftDetail.shiftPasspoints[i].index = 'G' + shiftDetail.shiftPasspoints[i].index
            shiftDetail.shiftPasspoints[i].stationIndex = stationIndex
            stationIndex++

            // 予約チェック
            shiftDetail.shiftPasspoints[i].startPassengers = []
            for(let j = 0; j < shiftDetail.shiftInfo.shiftReservationInfos.length; j++){
              if(shiftDetail.shiftPasspoints[i].stationId == shiftDetail.shiftInfo.shiftReservationInfos[j].startStationId){
                // 出発地
                shiftDetail.shiftPasspoints[i].stopFlag = true
                shiftDetail.shiftPasspoints[i].showPassengers = true
                let startPassenger = {}
                startPassenger.name = shiftDetail.shiftInfo.shiftReservationInfos[j].lastName + ' ' + shiftDetail.shiftInfo.shiftReservationInfos[j].firstName
                shiftDetail.shiftPasspoints[i].startPassengers.push(startPassenger)
              }
              if(shiftDetail.shiftPasspoints[i].stationId == shiftDetail.shiftInfo.shiftReservationInfos[j].arriveStationId){
                // 到着地
                shiftDetail.shiftPasspoints[i].stopFlag = true
              }
            }
          }
          
        }
        this.shiftPasspoints = shiftDetail.shiftPasspoints
        console.log("予約者チェック後の停留所リスト")
        console.log(this.shiftPasspoints)

        // 获取修改前具体时台、分钟
        if (this.goBackFlag === '0') {
          let oldHourMin = DateUtil.hourMin(this.shiftPasspoints[0].estimateTime).split(':')
          this.oldTimeHour = oldHourMin[0]
          if (oldHourMin[1].charAt(0) === '0') {
            this.oldTimeMinute = oldHourMin[1].charAt(1)
          } else {
            this.oldTimeMinute = oldHourMin[1]
          }
        } else {
          let oldHourMin = DateUtil.hourMin(this.shiftPasspoints[this.shiftPasspoints.length - 1].estimateTime).split(':')
          this.oldTimeHour = oldHourMin[0]
          if (oldHourMin[1].charAt(0) === '0') {
            this.oldTimeMinute = oldHourMin[1].charAt(1)
          } else {
            this.oldTimeMinute = oldHourMin[1]
          }
        }

        // alert(this.oldTimeHour + '   ' + this.oldTimeMinute)
        for (let i = 0; i < this.shiftPasspoints.length; i++) {
          // 给每个经由地添加相应字段值
          this.shiftPasspoints[i].shiftId = shiftInfo.shiftId
          this.shiftPasspoints[i].routeNo = shiftDetailPasspoints[i].routeNo
          this.shiftPasspoints[i].sortNo = shiftDetailPasspoints[i].sortNo
          this.shiftPasspoints[i].startEstimateTime = shiftDetailPasspoints[i].startEstimateTime
          this.shiftPasspoints[i].arriveEstimateTime = shiftDetailPasspoints[i].arriveEstimateTime
          // 给时、分集合赋值
          // let hourMin = DateUtil.hourMin(this.shiftPasspoints[i].estimateTime).split(':')
          let hourMin
          if(this.shiftPasspoints[i].estimateTime == null || this.shiftPasspoints[i].estimateTime === "" ){
            hourMin = [null,null]
          }else{
            hourMin = DateUtil.hourMin(this.shiftPasspoints[i].estimateTime).split(':')
          }
          this.hourList[i] = hourMin[0]
          if (hourMin[1] != null && hourMin[1].charAt(0) === '0') {
            this.minuteList[i] = hourMin[1].charAt(1)
          } else {
            this.minuteList[i] = hourMin[1]
          }
          if (this.shiftPasspoints[i].reserveId !== '' && this.shiftPasspoints[i].reserveId !== null) {
            this.passpointNum++
          }
        }
        this.$emit('updateShiftList', shiftDetailPasspoints, this.shiftIndex)
      }
      console.log("getShiftPasspoints result")
      console.log(this.shiftPasspoints)

      this.$emit('getHour', this.hourList, this.shiftIndex)
      this.$emit('getMinute', this.minuteList, this.shiftIndex)
    },
    // 选择route
    chooseRoute (val) {
      console.log("chooseRoute Editor")
      this.selectedRouteStationInfo = []
      this.routeStationInfo.forEach(item => {
        if (item.routeId === val) {
          this.selectedRouteStationInfo.push(item)
        }
      })
      console.log( this.selectedRouteStationInfo)
      // 根据経由地番号进行排序
      if (this.selectedRouteStationInfo.length > 0) {
        this.selectedRouteStationInfo.sort((a, b) => { return a.routeNo - b.routeNo })
      }

      this.selectChange = true
      if (this.oldRouteId !== this.routeId) {
        this.routeChangeFlag = true
      } else {
        this.routeChangeFlag = false
      }
      // 将选中的route相关的所有信息传到父组件
      this.$emit('getSelectedRouteStationInfo', this.selectedRouteStationInfo, this.shiftIndex)
    },
    // 時間を自動計算する
    computeValidate () {
      console.log("computeValidate")
      if (this.timeValidate()) {
        let latLngList = []

        if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
          for (let i = this.shiftPasspoints.length - 1; i >= 0; i--) {
            let latLngObject = {}
            latLngObject.lat = this.shiftPasspoints[i].stationLat
            latLngObject.lng = this.shiftPasspoints[i].stationLng
            latLngList[this.shiftPasspoints.length - 1 - i] = latLngObject
          }
        } else {
          for (let i = 0; i < this.shiftPasspoints.length; i++) {
            let latLngObject = {}
            latLngObject.lat = this.shiftPasspoints[i].stationLat
            latLngObject.lng = this.shiftPasspoints[i].stationLng
            latLngList[i] = latLngObject
          }
        }
        PlannRoute(latLngList, false).then(response => {
          // 自动推算乘车预定时间
          if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
            // 重组数据
            let estimateHour = this.hourList[this.hourList.length - 1] < 10 ? '0' + this.hourList[this.hourList.length - 1] : this.hourList[this.hourList.length - 1]
            let estimateMinute = this.minuteList[this.minuteList.length - 1] < 10 ? '0' + this.minuteList[this.minuteList.length - 1] : this.minuteList[this.minuteList.length - 1]
            let lastEstimateTime = estimateHour + ':' + estimateMinute
            let time
            if(this.transportKind === 0){
              time = DateUtil.planTimeList(response, lastEstimateTime, this.goBackFlag)
            }else{
              // 帰り区域外
              time = DateUtil.planTimeList(response, lastEstimateTime, '0')
            }

            console.log(time)
            // 显示当前自动计算时间
            let j = 0
            for (let i = this.shiftPasspoints.length - 2; i >= 0; i--) {
              this.$set(this.hourList, i, time[j].hour)
              this.$set(this.minuteList, i, time[j].min)
              j++
            }
          } else {
            let estimateHour = this.hourList[0] < 10 ? '0' + this.hourList[0] : this.hourList[0]
            let estimateMinute = this.minuteList[0] < 10 ? '0' + this.minuteList[0] : this.minuteList[0]
            let lastEstimateTime = estimateHour + ':' + estimateMinute
            let time
            if(this.transportKind === 0){
              time = DateUtil.planTimeList(response, lastEstimateTime, this.goBackFlag)
            }else{
              // 行き区域外
              time = DateUtil.planTimeList(response, lastEstimateTime, '1')
            }
            console.log(time)
            for (let i = 1; i < this.shiftPasspoints.length; i++) {
              this.$set(this.hourList, i, time[i - 1].hour)
              this.$set(this.minuteList, i, time[i - 1].min)
            }
          }
          this.$emit('getHour', this.hourList, this.shiftIndex)
          this.$emit('getMinute', this.minuteList, this.shiftIndex)
        })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // 判断是否是最后一个经由地
    checkLast (passIndex) {
      return passIndex != String(this.passpointNum)
    },
    // 向上箭头操作：即上升当前passpoint位置,其中key：在shiftPasspoints中的下标，index为shiftPasspoint.index(与上面相邻对象交换，不要忘记时间的操作？？？)
    upPassPoint (nowKey, nowIndex) {
      console.log("upPassPoint")
      console.log(this.shiftPasspoints)
      console.log(nowKey)
      console.log(nowIndex)
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        let upIndex = nowIndex - 1
        // let upIndex = String(Number(nowIndex) - 1)
        let upKey = 0
        for (let i = 0; i < this.shiftPasspoints.length; i++) {
          if (this.shiftPasspoints[i].index === upIndex) {
            upKey = i
            break
          }
        }

        // 交换两者在順番sortNo
        let tempSortNo = this.shiftPasspoints[upKey].sortNo
        this.shiftPasspoints[upKey].sortNo = this.shiftPasspoints[nowKey].sortNo
        this.shiftPasspoints[nowKey].sortNo = tempSortNo

        // 交换两者在数组的位置,并修改index
        this.shiftPasspoints[upKey].index = nowIndex
        this.shiftPasspoints[nowKey].index = upIndex
        let tempShiftPasspoint = this.shiftPasspoints[upKey]
        this.shiftPasspoints[upKey] = this.shiftPasspoints[nowKey]
        this.shiftPasspoints[nowKey] = tempShiftPasspoint
        this.computeValidate ()
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    // 向下箭头操作：即下降当前passpoint位置
    downPassPoint (nowKey, nowIndex) {
      console.log("upPassPoint")
      console.log(this.shiftPasspoints)
      console.log(nowKey)
      console.log(nowIndex)
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        let downIndex = nowIndex + 1
        // let downIndex = String(Number(nowIndex) + 1)
        let downKey = 0
        for (let i = 0; i < this.shiftPasspoints.length; i++) {
          if (this.shiftPasspoints[i].index === downIndex) {
            downKey = i
            break
          }
        }

        // 交换两者在順番sortNo
        let tempSortNo = this.shiftPasspoints[downKey].sortNo
        this.shiftPasspoints[downKey].sortNo = this.shiftPasspoints[nowKey].sortNo
        this.shiftPasspoints[nowKey].sortNo = tempSortNo

        // 交换两者在数组的位置,并修改index
        this.shiftPasspoints[downKey].index = nowIndex
        this.shiftPasspoints[nowKey].index = downIndex
        let tempShiftPasspoint = this.shiftPasspoints[downKey]
        this.shiftPasspoints[downKey] = this.shiftPasspoints[nowKey]
        this.shiftPasspoints[nowKey] = tempShiftPasspoint
        this.computeValidate ()
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    // 获得在该停留所上车乘客的名字
    getPassengerNames (key) {
      let name = ''
      for (let i = 0; i < this.shiftPasspoints[key].startPassengers.length; i++) {
        if (i === this.shiftPasspoints[key].startPassengers.length - 1) {
          name = name + this.shiftPasspoints[key].startPassengers[i].name
        } else {
          name = name + this.shiftPasspoints[key].startPassengers[i].name + '、'
        }
      }
      return name
    },
    // 父组件保存时整合该组件的数据shiftPasspoints数组
    savePasspoints (moveShiftTime, shiftIndex) {
      let estimateTimeSlot
      for (let i = 0; i < this.shiftPasspoints.length; i++) {
        let hour = Number(this.hourList[i]) >= 10 ? this.hourList[i] : '0' + this.hourList[i]
        let minute = Number(this.minuteList[i]) >= 10 ? this.minuteList[i] : '0' + this.minuteList[i]
        let estimateTime = moveShiftTime + hour + minute + '00'
        // 行
        if (this.goBackFlag === '0') {
          // 时台字段
          if (i === 0) {
            // 有乘车人时才判断是否保留修改前的时间 （如果登录到便basic表和passpoint表的字段值不同的话，将下面的放到this.shiftPasspoints[i]中的值startEstimateTime和estimateTime修改成对应的值（对应的estimateTimeSlot换别名），而estimateTimeSlot存放basic表里面对应的不含分钟的值）
            // 另外，保存时时间校验是否校验存basic表里面的还是passpoint里面的
            if (this.reserveNumber > 0) {
              let oldHour = Number(this.oldTimeHour) >= 10 ? this.oldTimeHour : '0' + this.oldTimeHour
              let oldMinute = Number(this.oldTimeMinute) >= 10 ? this.oldTimeMinute : '0' + this.oldTimeMinute
              // 时台时与修改前相同
              if (Number(oldHour) === Number(hour)) {
              // 判断是否小于紧邻的时间
                if (Number(oldHour) === Number(Number(this.hourList[i + 1]) >= 10 ? this.hourList[i + 1] : '0' + this.hourList[i + 1])) {
                  if (Number(oldMinute) >= Number(Number(this.minuteList[i + 1]) >= 10 ? this.minuteList[i + 1] : '0' + this.minuteList[i + 1])) {
                    estimateTimeSlot = moveShiftTime + hour + '0000'
                  } else {
                    estimateTimeSlot = moveShiftTime + oldHour + oldMinute + '00'
                  }
                } else {
                  estimateTimeSlot = moveShiftTime + oldHour + oldMinute + '00'
                }
              } else {
                estimateTimeSlot = moveShiftTime + hour + '0000'
              }
            } else {
              estimateTimeSlot = moveShiftTime + hour + '0000'
            }

            this.shiftPasspoints[i].startEstimateTime = estimateTimeSlot // 按理为''
            this.shiftPasspoints[i].arriveEstimateTime = ''
            this.shiftPasspoints[i].estimateTime = estimateTimeSlot
          } else {
            this.shiftPasspoints[i].startEstimateTime = ''
            this.shiftPasspoints[i].arriveEstimateTime = estimateTime
            this.shiftPasspoints[i].estimateTime = estimateTime
          }
        } else {
          if (i === 0) {
            this.shiftPasspoints[i].startEstimateTime = estimateTime
            this.shiftPasspoints[i].arriveEstimateTime = ''
            this.shiftPasspoints[i].estimateTime = estimateTime
          } else {
            if (i === this.shiftPasspoints.length - 1) {
              if (this.reserveNumber > 0) {
                let oldHour = Number(this.oldTimeHour) >= 10 ? this.oldTimeHour : '0' + this.oldTimeHour
                let oldMinute = Number(this.oldTimeMinute) >= 10 ? this.oldTimeMinute : '0' + this.oldTimeMinute
                // 时台时与修改前相同
                if (Number(oldHour) === Number(hour)) {
                  // 判断是否大于紧邻的时间
                  if (Number(oldHour) === Number(Number(this.hourList[i - 1]) >= 10 ? this.hourList[i - 1] : '0' + this.hourList[i - 1])) {
                    if (Number(oldMinute) <= Number(Number(this.minuteList[i - 1]) >= 10 ? this.minuteList[i - 1] : '0' + this.minuteList[i - 1])) {
                      estimateTimeSlot = moveShiftTime + hour + '0000'
                    } else {
                      estimateTimeSlot = moveShiftTime + oldHour + oldMinute + '00'
                    }
                  } else {
                    estimateTimeSlot = moveShiftTime + oldHour + oldMinute + '00'
                  }
                } else {
                  estimateTimeSlot = moveShiftTime + hour + '0000'
                }
              } else {
                estimateTimeSlot = moveShiftTime + hour + '0000'
              }
              // estimateTimeSlot = moveShiftTime + hour + '0000'
              this.shiftPasspoints[i].startEstimateTime = ''
              this.shiftPasspoints[i].arriveEstimateTime = estimateTimeSlot // 按理为''
              this.shiftPasspoints[i].estimateTime = estimateTimeSlot
            } else {
              this.shiftPasspoints[i].startEstimateTime = ''
              this.shiftPasspoints[i].arriveEstimateTime = estimateTime
              this.shiftPasspoints[i].estimateTime = estimateTime
            }
          }
        }
      }

      // 更新预约者情报数组
      for (let i = 0; i < this.shiftReservationInfos.length; i++) {
        // 乗車予定日時
        if (this.shiftReservationInfos[i].startPlaceType === 2) {
          let stationId = this.shiftReservationInfos[i].startStationId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => (item.stationId === stationId && item.routeType === '0'))
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].startEstimateTime = findshiftPasspoints[0].estimateTime
          }
        } else {
          let reserveId = this.shiftReservationInfos[i].reserveId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => item.reserveId === reserveId)
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].startEstimateTime = findshiftPasspoints[0].estimateTime
          }
        }
        // 降車予定日時
        if (this.shiftReservationInfos[i].arrivePlaceType === 2) {
          let stationId = this.shiftReservationInfos[i].arriveStationId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => (item.stationId === stationId && item.routeType === '0'))
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].arriveEstimateTime = findshiftPasspoints[0].estimateTime
          }
        } else {
          let reserveId = this.shiftReservationInfos[i].reserveId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => item.reserveId === reserveId)
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].arriveEstimateTime = findshiftPasspoints[0].estimateTime
          }
        }
      }
      console.log("this.shiftPasspoints")
      console.log(this.shiftPasspoints)
      this.$emit('editorShiftPasspoints', this.shiftPasspoints, this.shiftReservationInfos, estimateTimeSlot, shiftIndex)
      this.$emit('getHour', this.hourList, shiftIndex)
      this.$emit('getMinute', this.minuteList, shiftIndex)
    },
    // 选择hour
    clickHour () {
      this.$emit('getHour', this.hourList, this.shiftIndex)
    },
    // 选择hour
    clickMinute () {
      this.$emit('getMinute', this.minuteList, this.shiftIndex)
    },
  }
}
</script>

<template>
    <div class="clearfix"  style="margin-top:-5px">
        <div class="clearfix" v-for="(shiftPasspoint,key) in shiftPasspoints" :key="key">
          <div class="col-md-7 column paddingTop">
            <div class="row clearfix">
            <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15"  style="width:22.2%">
              <div class="row clearfix">
                <div class="col-md-12 column clearfix" v-if="shiftPasspoint.index==='S'">
                  出発地
                </div>
                <div class="col-md-12 column clearfix" v-else-if="shiftPasspoint.index==='G'">
                  終着地
                </div>
                <div class="col-md-12 column clearfix" v-else-if="shiftPasspoint.routeType==='0'">
                  停留所{{shiftPasspoint.stationIndex}}
                </div>
                <div class="col-md-12 column clearfix" v-else>
                  経由地{{shiftPasspoint.index}}
                </div>
              </div>
             </div>
            <div class="col-md-4 column stationWidth" >
              <div class="divTitle longsolid passengerdiv F3-R-20 bgc5" v-if="shiftPasspoint.routeType==='1'" >
                <div style="flex:8" class="overflow-fix">
                  {{shiftPasspoint.name}}
                </div>
                <div  class="upAbleArrow" v-if="shiftPasspoint.index!='1'" @click="upPassPoint(key,shiftPasspoint.index)"></div> <div  class="upDisableArrow" v-else></div>
                <div  class="downAbleArrow" v-if="checkLast(shiftPasspoint.index)" @click="downPassPoint(key,shiftPasspoint.index)"></div><div  class="downDisableArrow" v-else></div>
              </div>
              <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix" v-else-if="passpointNum === 0 && reserveNumber===0 ">{{shiftPasspoint.name}}</div>
               <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix" v-else-if="shiftPasspoint.stopFlag===true && shiftPasspoint.showPassengers===true"> {{shiftPasspoint.name}}&nbsp;&nbsp;&nbsp;&nbsp;乗車者:{{getPassengerNames(key)}}</div>
              <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix" v-else-if="shiftPasspoint.stopFlag===true"> {{shiftPasspoint.name}}</div>
              <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix" v-else>↓<span class="stopFlaseValue">{{shiftPasspoint.name}}</span></div>
            </div>
            </div>
          </div>
          <div class="col-md-5 rightDivWidth paddingTop paddingBottom" :class="{bgc14:(shiftPasspoint.index==='S'&&goBackFlag==='0'&&transportKind===1)
                        ||(shiftPasspoint.index==='S'&&goBackFlag==='1'&&transportKind===0)
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='0'&&transportKind===0)
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='1'&&transportKind===1)
                        }">
            <div class="row clearfix">
            <div class="col-md-4 column divTitle shortDiv bgc8 F3-R-15" style="width:35%;margin-left:10px">
              <div class="row clearfix">
                <div class="col-md-3 column clearfix"
                    v-if="(shiftPasspoint.index==='S'&&goBackFlag==='0'&&transportKind===1)
                        ||(shiftPasspoint.index==='S'&&goBackFlag==='1'&&transportKind===0)
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='0'&&transportKind===0)
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='1'&&transportKind===1)">
                  ※
                </div>
                <div class="col-md-3 column clearfix" v-else>
                </div>
                <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft" v-if="shiftPasspoint.index==='S'">
                  出発予定時間
                </div>
                <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft" v-else>
                  到着予定時間
                </div>
              </div>
            </div>
            <div class="col-md-3 column paddingRightZero">
              <div class="clearfix">
              <!-- <select v-if="(shiftPasspoint.index==='S'&&goBackFlag==='0')||(shiftPasspoint.index==='G'&&goBackFlag==='1')"
              :class="{selectstyles:true, selectImg:true}"
              :name="`selectHour${key}`" v-validate="{required:  startEndTimeValidateFlag && (shiftPasspoint.index==='S'||shiftPasspoint.index==='G')}"
              v-model="hourList[key]" @change="clickHour">
              <option v-for="n in 19" :key="n" :value="n+3">{{n+3>9?n+3:"0"+(n+3)}}</option>
              </select> -->
              <select :class="{selectstyles:true, selectImg:true}" v-if="(passpointNum === 0 && reserveNumber===0) || shiftPasspoint.stopFlag===true"
               :name="`selectHour${key}`" v-validate="{required: startEndTimeValidateFlag 
                        && ((shiftPasspoint.index==='S'&&goBackFlag==='0'&&transportKind===1)
                        ||(shiftPasspoint.index==='S'&&goBackFlag==='1'&&transportKind===0)
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='0'&&transportKind===0)
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='1'&&transportKind===1)) }"
              v-model="hourList[key]" @change="clickHour">
              <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
              <select :class="{selectstyles:true, selectImg:true}" class="stopFlaseValue" v-else-if="shiftPasspoint.stopFlag===false " disabled="disabled"
              v-model="hourList[key]" @change="clickHour">
              <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
              </div>
              <div class="clearfix" style="width:200px">
                <span v-if="errors.has(`selectHour${key}`)" class="errorMessage"> {{ errors.first(`selectHour${key}`) }} </span>
                <span v-else-if="errors.has(`selectMinute${key}`)" class="errorMessage"> {{ errors.first(`selectMinute${key}`) }} </span>
                <span v-else-if="(transportKind == 0)&&((shiftPasspoint.index==='S'&&goBackFlag==='1')||(shiftPasspoint.index==='G'&&goBackFlag==='0'))&&timeValidateFlag" class="errorMessage">
                   必須入力項目が未入力です。
                </span>
                <span v-else-if="(transportKind == 1)&&((shiftPasspoint.index==='G'&&goBackFlag==='1')||(shiftPasspoint.index==='S'&&goBackFlag==='0'))&&timeValidateFlag" class="errorMessage">
                   必須入力項目が未入力です。
                </span>
              </div>
            </div>
            <!-- <div class="col-md-1 column aloneWordDiv F3-R-17" style="width:11%"
              v-if="(shiftPasspoint.index==='S'&&goBackFlag==='0')||(shiftPasspoint.index==='G'&&goBackFlag==='1')">
              時台
            </div> -->
            <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17">
              時
            </div>
            <div class="col-md-3 column paddingLeftZero">
              <select :class="{selectstyles:true, selectImg:true}" v-if="(passpointNum === 0 && reserveNumber===0) || shiftPasspoint.stopFlag===true "
               :name="`selectMinute${key}`"
               v-validate="{required: ((shiftPasspoint.index==='S'&&goBackFlag==='0'&&transportKind===1)
                                    ||(shiftPasspoint.index==='S'&&goBackFlag==='1'&&transportKind===0)
                                    ||(shiftPasspoint.index==='G'&&goBackFlag==='0'&&transportKind===0)
                                    ||(shiftPasspoint.index==='G'&&goBackFlag==='1'&&transportKind===1))}"
               v-model="minuteList[key]" @change="clickMinute">
              <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
              <select :class="{selectstyles:true, selectImg:true}" class="stopFlaseValue" v-else-if="shiftPasspoint.stopFlag===false" disabled="disabled"
               v-model="minuteList[key]">
              <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
            </div>
            <!-- <div class="col-md-3 column paddingLeftZero"
              v-else-if="(shiftPasspoint.index!=='G'&&goBackFlag==='1')">
              <select :class="{selectstyles:true, selectImg:true}"  v-if="(passpointNum === 0 && reserveNumber===0) || shiftPasspoint.stopFlag===true "
               :name="`selectMinute${key}`"
               v-validate="{required: (shiftPasspoint.index==='S')}"
               v-model="minuteList[key]">
              <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
              <select :class="{selectstyles:true, selectImg:true}" class="stopFlaseValue" v-else-if="shiftPasspoint.stopFlag===false" disabled="disabled"
               v-model="minuteList[key]">
              <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
            </div> -->
            <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17" style="margin-left: -15px">
              分
            </div>
            </div>
          </div>
        </div>
        <div class="clearfix" v-if="selectedRouteStationInfo.length > 0 && timeError === true">
          <div class="col-md-7 column">
          </div>
          <div class="col-md-5 column errorMessage paddingTop paddingBottom rightDivWidth">
            入力時間の順序が不正です。
          </div>
        </div>
        <div class="clearfix" v-if="selectedRouteStationInfo.length > 0 && shiftTimeError === true">
          <div class="col-md-7 column">
          </div>
          <div class="col-md-5 column errorMessage paddingTop paddingBottom rightDivWidth">
            未入力の項目があります。
          </div>
        </div>
        <div class="clearfix">
          <div class="col-md-7 column">
          </div>
          <div class="col-md-5 column rightDivWidth paddingTop bgc15" style="height: 92px; z-index: 2;">
            <div class="row clearfix">
            <button class="T7-radius F2-R" @click="computeValidate">
            時間を自動計算する
            </button>
            </div>
            <div class="row clearfix F2-R" style="margin-top:5px">
              <div class="col-md-1 column clearfix paddingRightZero">
                ※
              </div>
              <div class="col-md-11 column clearfix textAlignLeft paddingLeftZero">
                赤枠の時刻を入力した後、「時間を自動計算する」ボタンを押してください
              </div>
            </div>
          </div>
       </div>
        <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
    </div>
</template>

<style scoped>
.divTitle {
  height: 50px;
  line-height: 50px;
}
.T7-radius {
  width: 100%;
  max-width: 250px;
  height: 40px;
  background: linear-gradient(#888886 50%, #696a65 50%) !important;
  border-radius: 30px;
  text-align: center;
  padding: 0;
  border: 0;
}
.selectstyles {
  border: solid 1px #ccc;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  padding-left: 12px;
  background-color: white !important;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../assets/dropselect.png") no-repeat scroll right center transparent;
}
.longsolid {
  padding: 0px 12px;
  text-align: left;
}
.textAlignLeft {
  text-align: left;
}
.paddingLeftZero {
  padding-left: 0px;
}
.paddingRightZero {
  padding-right: 0px;
}
.stationWidth {
  width: 77%;
}
.shortDiv {
  width: 13%;
  min-width: 120px;
}
.divMarginTop {
  margin-top: 10px;
}
.aloneWordDiv{
  display:flex;
  align-items:center;
  justify-content:center;
  height:50px;
  padding-left: 0px;
  padding-right: 0px;
}

/* 关于值的列的设置（浅色） */
.stopFlaseValue{
  /* border: 1px solid #959595; */
  /* color:#bbbbbb; */
  color:#bbbbbb;
}
.passengerdiv {
  display: flex;
  flex-direction: row;
}
.upAbleArrow{
  margin-top: 5px;
  height: 40px;
  width:40px;
  margin-right: 3px;
  background: url("../assets/button/list_up_button1.png") no-repeat scroll right center transparent;
}
.upDisableArrow{
  margin-top: 5px;
  height: 40px;
  width:40px;
  margin-right: 3px;
  background: url("../assets/button/list_up_button2.png") no-repeat scroll right center transparent;
}
.downAbleArrow{
  margin-top: 5px;
  height: 40px;
  width: 40px;
  margin-right: -5px;
  background: url("../assets/button/list_down_button1.png") no-repeat scroll right center transparent;
}
.downDisableArrow{
  margin-top: 5px;
  height: 40px;
  width: 40px;
  margin-right: -5px;
  background: url("../assets/button/list_down_button2.png") no-repeat scroll right center transparent;
}
.errorMessage {
  color: red;
}
.rightDivWidth{
  width:37%;
}
.paddingTop{
  padding-top: 5px;
}
.paddingBottom{
  padding-bottom: 5px;
}
.timeWidth{
  width: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/PassPointInfoComponent.vue